var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBirdEmptyResult = function SvgBirdEmptyResult(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 260 260"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#146CFF",
    clipPath: "url(#bird-empty-result_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 260,
    fillOpacity: 0.04,
    rx: 20.8
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "m210.25 124.888-18.565-18.255-.074.537-2.415 17.671zM165.783 112.52l21.263 19.274-.013.008.022.021.953-6.983 2.415-17.672.077-.581z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.2,
    d: "m117.683 133.309-.212.619-9.485 67.876 28.8-25.985-.779-1.735-.526-1.165-17.587-39.141z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "m116.722 133.598-32.585-32.222-34.737-.883 67.212 33.42zM116.891 132.557l.103-.302 2.2-59.422-62.129.56 27.245 26.942z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.2,
    d: "M165.022 113.414 120.21 72.8l-.224.003-2.172 58.746 18.017 40.095 50.197-38.762.244-.185.012-.012z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "m186.679 133.676-50.418 38.929.526 1.171 48.728-30.108 1.402-10.174z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bird-empty-result_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 260,
    fill: "#fff",
    rx: 130
  })))));
};
export default SvgBirdEmptyResult;